import { render, staticRenderFns } from "./NotificationCreateHeader.vue?vue&type=template&id=f03b3ec8&"
import script from "./NotificationCreateHeader.vue?vue&type=script&lang=ts&"
export * from "./NotificationCreateHeader.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationCreateHeader.vue?vue&type=style&index=0&id=f03b3ec8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports